export default [
	{
		path: "/pros/contacts",
		exact: true,
		policy: "providerAuth",
		component: "Contacts",
		mui: true,
	},
];
